import { createStyles } from 'antd-style'

import { FlowIntroduceDividerProps } from './interface'

const useStyles = createStyles(({ token }) => ({
  line: {
    position: 'absolute',
    left: -16,
    width: 1,
    height: 64,
    backgroundColor: token.colorBorder
  },
  arrow: {
    position: 'absolute',
    left: -16,
    width: 16,
    height: 16,
    clipPath: 'polygon(0 0, 100% 50%, 0 100%, 70% 50%)',
    backgroundColor: token.colorBorder
  }
}))

export const FlowIntroduceDivider = ({ type }: FlowIntroduceDividerProps) => {
  const { styles } = useStyles()

  return <div className={styles[type]} />
}
